import { PublicationListOrderingKey } from "@/components/business/PublicationListContainer/publicationList.types";
import { invalidatePublicationListFilterQuery } from "@api/publicationList/usePublicationListFilter";

import { useHandlePublicationListTableOrdering } from "./hooks/useHandlePublicationListTableOrdering";
import * as S from "./PublicationListTableHead.style";
import {
  Ordering,
  TableHeaderList,
} from "../../constants/publicationListTable.constants";

const PublicationListTableHead = () => {
  const { tableHeaderList, checkIsOrdering, getOrderingIcon, handleOrdering } =
    useHandlePublicationListTableOrdering();
  const updatePublicationList = invalidatePublicationListFilterQuery;

  const handleClickOrdering = (
    orderingTitle: PublicationListOrderingKey,
    ordering: Ordering,
  ) => {
    handleOrdering(orderingTitle, ordering);
    updatePublicationList();
  };

  return (
    <S.PressListTableHead>
      <S.TableRow>
        {tableHeaderList.map((item: TableHeaderList) => (
          <S.TableHeadShell
            key={`thead-${item.title}`}
            onClick={() =>
              handleClickOrdering(item.orderingTitle, item.ordering)
            }
          >
            <S.TableHeadShellContents
              isOrdering={checkIsOrdering(item.ordering)}
            >
              <S.TableHeadShellTitle
                isOrdering={checkIsOrdering(item.ordering)}
              >
                {item.title
                  .split("\n")
                  .map((word: string, wordIndex: number) => (
                    <S.TableHeadShellTitleWord key={word + String(wordIndex)}>
                      {word}
                    </S.TableHeadShellTitleWord>
                  ))}
              </S.TableHeadShellTitle>

              <S.OrderingIconWrapper>
                {getOrderingIcon(item.ordering)}
              </S.OrderingIconWrapper>
            </S.TableHeadShellContents>
          </S.TableHeadShell>
        ))}
      </S.TableRow>
    </S.PressListTableHead>
  );
};

export default PublicationListTableHead;
